import React from "react";
import { FlexColumn } from "@/ui/FlexContainer/FlexContainer";
import Typography from "@/ui/Typography/Typography";
import { useTranslation } from "react-i18next";
import { useUserDataContext } from "@/store/UserProvider";
import { ArrowIcon } from "@/assets/icons";
import cls from "./styles.module.scss";

export const SubscriptionBlock = ({ onClick }: { onClick: () => void }) => {
  const { t } = useTranslation();
  const { user } = useUserDataContext();
  const price = user?.subscription_price || 299;
  const sale = Math.round(100 - (price * 100) / 399);

  return (
    <FlexColumn gap={12} className={cls.subscriptionBlock}>
      <Typography className={cls.subscriptionBlockLabel}>
        {t("common.accessTo")}
      </Typography>

      <Typography className={cls.priceBlock}>
        <span className={cls.price}>{user?.subscription_price} ₽</span> /мес{" "}
        <s>399₽</s> <span className={cls.percentBlock}>−{sale}%</span>
      </Typography>

      <Typography className={cls.subscriptionBlockDesc}>
        {t("common.viewAllPoints")}
      </Typography>

      <button type="button" className={cls.subscriptionBtn} onClick={onClick}>
        <Typography>{t("common.subscribe")}</Typography>
        <ArrowIcon />
      </button>
    </FlexColumn>
  );
};
